import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { HeaderAndNavigationService } from "../headerandnavigation.service";
import { LoaderService } from "../../LoaderService";
import { Register } from "./register";
declare var $: any;


@Component({
    templateUrl: './register.component.html'
})
export class RegisterComponent {
    registerForm: FormGroup;
    register: Register = new Register();
    errorMessage: string;
    public loading = false;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private appCommonService: AppCommonService,
        private router: Router,
        public globalService: GlobalService,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService
    ) { }

    ngOnInit(): void {
        this.appCommonService.pageContentAdditionalClass = "home-page login-page";
        this.registerForm = this.fb.group({
            FullName: ['', [Validators.required]],
            CompanyName: ['', [Validators.required]],
            Email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]],
            Telephone: ['', [Validators.required]],
            Postcode: ['', [Validators.required]],
            //EnquiryDetail: ['', [Validators.required]],
            EnquiryDetail: '',
            DecisionMaker: ['', [Validators.required]],
            FuelCardHolder: ['', [Validators.required]],
            AccountNumber: ['']
        });
    }

    OnRegister(): void {
        if (this.registerForm.dirty && this.registerForm.valid) {
            // Copy the form values over the product object values
            let p = Object.assign({}, this.register, this.registerForm.value);
            this.loaderService.display(true);
            this.headerAndNavigationService.callRegister(p)
                .subscribe(
                () => {
                    //$('#forgotpassModal').modal('show');
                    this.router.navigate(['/registerconfirmation']);
                    this.onRegisterComplete();
                    this.loaderService.display(false);
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.globalService.showError("Register", <any>error)
                }
                );
        } else if (!this.registerForm.dirty) {
            this.onRegisterComplete();
        }
    }

    onRegisterComplete(): void {
        // Reset the form to clear the flags
        this.registerForm.reset();
    }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/register/register.component.ts